import { createSlice } from '@reduxjs/toolkit';
const style = {
    display: 'block',
    zIndex: -2,
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0'
};
export const initialState = { style, stableElementHeight: null };
export const iFrameSlice = createSlice({
    name: 'iframe',
    initialState,
    reducers: {
        setStyle: (state, action) => {
            state.style = Object.assign(Object.assign({}, state.style), action.payload);
        },
        setStableIframeHeight: (state, { payload }) => {
            state.stableElementHeight = payload;
        }
    },
    extraReducers: (builder) => { }
});
export const { setStyle, setStableIframeHeight } = iFrameSlice.actions;
export default iFrameSlice.reducer;
